import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type ForgotPasswordRequest = {
  username: string;
};
export const requestForgotPassword = async (requestBody: ForgotPasswordRequest) => {
  try {
    const result = await post('/guest/forgotPassword', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
